import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { IMAGES_REPO } from '../../config';

class Service extends PureComponent {

  render() {
    const { code, id, body, image, title, numOfComments = 0 } = this.props;
    return (
      <div className="service">
        <div className="service-link">
          <div className="service-hover">
            <div className="service-hover-content">
              <Link to={`/services/${code}`}>
                <button className="btn btn-xl">ver mais</button>
              </Link>
            </div>
          </div>
          <img className="img-responsive" src={`${IMAGES_REPO}${image}`} alt={title}/>
        </div>
        <div className="service-caption">
          <div className="first">
            <h4 className="sub-title">{title}</h4>
          </div>
          <div className="last">
            <span className="comments">
              {numOfComments > 0 && <span>{numOfComments} <i className="fa fa-comments"></i></span>}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

Service.propTypes = {};
Service.defaultProps = {};

export default Service;



// WEBPACK FOOTER //
// ./src/components/service/Service.js